import { ThreadEventItem } from './ThreadEventItem';
import { Skeleton } from '@/components/ui/skeleton';
import type { ThreadEvent } from '@/hooks/useTicketThread';

interface ThreadEventListProps {
  events: ThreadEvent[];
  isLoading?: boolean;
}

export function ThreadEventList({ events, isLoading }: ThreadEventListProps) {
  if (isLoading) {
    return (
      <div className="space-y-4 p-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex gap-3">
            <Skeleton className="h-8 w-8 rounded-full shrink-0" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-16 w-full rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center mb-3">
          <span className="text-2xl">📭</span>
        </div>
        <p className="text-sm text-muted-foreground">No activity yet</p>
        <p className="text-xs text-muted-foreground mt-1">
          Events will appear here as work progresses
        </p>
      </div>
    );
  }

  return (
    <div className="p-4">
      {events.map((event, index) => (
        <ThreadEventItem 
          key={event.id} 
          event={event} 
          isLast={index === events.length - 1}
        />
      ))}
    </div>
  );
}
